import { useAuthStore } from '@/store/useAuthStore';
import { logout } from '@/api/auth.api';

export function NoAccessPage() {
  const user = useAuthStore((s) => s.user);
  const clearAuth = useAuthStore((s) => s.clearAuth);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 px-6 text-center">
      <div className="text-6xl">🔒</div>
      <h1 className="text-2xl font-semibold text-slate-800">Kein Zugriff</h1>
      <p className="max-w-md text-sm text-slate-600">
        Dein Konto hat aktuell keine Berechtigung für diesen Bereich. Bitte
        wende dich an einen Administrator, um eine passende Rolle zugewiesen zu
        bekommen.
      </p>
      {user && (
        <p className="text-xs text-slate-400">
          Angemeldet als <span className="font-medium">{user.email}</span>
        </p>
      )}
      <button
        type="button"
        onClick={async () => {
          // logout() nutzt den apiClient inkl. Authorization- und
          // X-CSRF-Token-Header – rohes fetch ohne CSRF-Token wurde vom
          // Backend mit 403 abgewiesen, sodass die Server-Session bestehen blieb.
          try {
            await logout();
          } catch {
            /* Auch bei Fehler lokal abmelden */
          }
          clearAuth();
          window.location.assign('/login');
        }}
        className="mt-2 rounded-md bg-slate-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-slate-800"
      >
        Abmelden
      </button>
    </div>
  );
}
